module.exports = __webpack_public_path__ + "media/images/a5-7c0ae721a3cfd4867a3677fa98a2dc03.jpg";